import { useState } from 'react';
import { useSiteHeaderFrame } from './useSiteHeaderFrame';
import styles from './SiteHeaderFrame.module.css';

/**
 * Embeds the header of the agency website above the form, so the application
 * looks like a step of that site rather than an external destination.
 *
 * The iframe is the deliberate choice: the site owns its own markup, styles and
 * assets, which resolve from its origin, and none of it can collide with the
 * global CSS of this app.
 *
 * @param {object} props
 * @param {string} props.url - Validated embed URL
 * @param {number} props.initialHeight - Pixels reserved before the first measure
 * @param {number} props.timeout - Milliseconds before dropping the header
 */
export const SiteHeaderFrame = ({ initialHeight, timeout, url }) => {
    const [frame, setFrame] = useState(null);
    const { hasFailed, height } = useSiteHeaderFrame({ frame, timeout, url });

    if (hasFailed) {
        return null;
    }

    // The embed page needs to know who is framing it, to address its messages.
    const source = `${url}${url.includes('?') ? '&' : '?'}host=${encodeURIComponent(window.location.origin)}`;

    return (
        <iframe
            className={styles.frame}
            height={height ?? initialHeight}
            ref={setFrame}
            referrerPolicy="origin"
            src={source}
            title="Agency website navigation"
        />
    );
};
